/**
 * True when the app is running under Playwright, either the local dev server
 * (port 4444) or the CI WAR on the build server.
 *
 * The narrower "CI WAR served at /connect/public" check that sets the router
 * basename combines this with the request path — see getBasename().
 */
export const isE2E = (): boolean => !!window.__PLAYWRIGHT__;
